import { createSelector } from "@reduxjs/toolkit";

export const selectAssistantManagementState = (state) => state.assistantManagement;

export const selectAssistants = createSelector(
  selectAssistantManagementState,
  (slice) => (slice?.allIds || []).map((id) => slice.byId[id]).filter(Boolean)
);

export const selectAssistantById = (assistantId) =>
  createSelector(selectAssistantManagementState, (slice) => {
    const id = String(assistantId ?? "").trim();
    return id ? slice?.byId?.[id] || null : null;
  });

export const selectAssistantListLoading = createSelector(
  selectAssistantManagementState,
  (slice) => Boolean(slice?.listLoading)
);

export const selectAssistantListError = createSelector(
  selectAssistantManagementState,
  (slice) => slice?.listError || null
);

export const selectAssistantMutationLoading = createSelector(
  selectAssistantManagementState,
  (slice) => Boolean(slice?.mutationLoading)
);

export const selectAssistantMutationError = createSelector(
  selectAssistantManagementState,
  (slice) => slice?.mutationError || null
);

export const selectAssistantActivationState = createSelector(
  selectAssistantManagementState,
  (slice) =>
    slice?.activation || {
      verifyLoading: false,
      verifyError: null,
      verifyData: null,
      setPasswordLoading: false,
      setPasswordError: null,
      setPasswordSuccess: false,
    }
);

export const selectAssistantAuthState = createSelector(
  selectAssistantManagementState,
  (slice) =>
    slice?.auth || {
      loading: false,
      error: null,
      isAuthenticated: false,
      accessToken: null,
      assistantId: null,
      doctorId: null,
    }
);

export const selectAssistantDoctorRendezvous = createSelector(
  selectAssistantManagementState,
  (slice) => slice?.doctorRendezvous?.items || []
);

export const selectAssistantDoctorRendezvousLoading = createSelector(
  selectAssistantManagementState,
  (slice) => Boolean(slice?.doctorRendezvous?.loading)
);

export const selectAssistantDoctorRendezvousError = createSelector(
  selectAssistantManagementState,
  (slice) => slice?.doctorRendezvous?.error || null
);
